// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"139":"b8ac0f97","543":"77a6cd16"}[chunkId] + ".css";
};